export function isPresent<T>(val: T | undefined | null | void): val is T {
  return val !== undefined && val !== null;
}
